import * as React from "react";
import { useEffect, useState } from "react";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Typography,
  Popover,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { investorApi, vendorApi } from "../../api/api";
import UpdateIcon from '@mui/icons-material/Update';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const Property = () => {
  const [rows, setRows] = React.useState([]);
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = React.useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [propertyTypeFilter, setPropertyTypeFilter] = useState("All");
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState("");
  const [selectedTeamMember, setSelectedTeamMember] = useState("");
  const [legalTeam, setLegalTeam] = useState([]);
  const [assignSaleModalOpen, setSaleAssignModalOpen] = useState(false);
  const [selectedSaleProperty, setSelectedSaleProperty] = useState(null);
  const [selectedSaleTeamMember, setSelectedSaleTeamMember] = useState("");
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleActionMenuOpen = (event, row) => {
    setActionMenuAnchor(event.currentTarget);
    setSelectedRow(row);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
    setSelectedRow(null);
  };

  const handleAction = (action, row) => {
    if (!row || !row.PropertyName) {
      return;
    }

   

    // Close menu first
    handleActionMenuClose();

    if (action === "edit") {
      navigate(`/property/editProperty?propertyId=${row.id}`, {
        state: {
          PropertyId: row.id,
          propertyName: row.PropertyName,
        },
      });
    } else if (action === "update") {
      navigate(`/property/marketPrice?propertyId=${row.id}`, {
        state: {
          PropertyId: row.id,
          propertyName: row.PropertyName,
          City: row.City,
          UnitPrice: row.UnitPrice,
          SizeInSqFt: row.SizeInSqFt,
        },
      });
    }
    else if (action === "view") {
      if (Number(row.PropertyType) === 2 || Number(row.PropertyType) === 4) {
        navigate(`/property/viewProperty?propertyId=${row.id}`, {
          state: {
            PropertyId: row.id,
            PropertyName: row.PropertyName,
            City: row.City,
            PropertyType: row.PropertyType,
            ProjectName: row.project_name,
            Address: row.Address,
            SizeInSqFt: row.SizeInSqFt,
            UnitPrice: row.UnitPrice,
            sqftamount: row.sqftamount,
            percentagevalue: row.percentagevalue,
            IconUrl: row.IconUrl,
            Status: row.Status
          },
        });
      } else if (Number(row.PropertyType) === 1) {
        navigate(`/viewProject/viewProject?projectId=${row.ProjectId}`, {
          state: {
            ProjectId: row.ProjectId,
            ProjectName: row.project_name,
            City: row.City,
            Address: row.Address,
            IconUrl: row.IconUrl,
            sqftamount: row.sqftamount,
            percentagevalue: row.percentagevalue,
          },
        });
      }
    }
    else if (action === "add") {
      navigate(`/property/addDocument?propertyId=${row.id}`, {
        state: {
          PropertyId: row.id,
          propertyName: row.PropertyName,
          City: row.City,
          UnitPrice: row.UnitPrice,
          SizeInSqFt: row.SizeInSqFt,
        },
      });
    }

    const routeMap = {
      approve: "/property/approveProperty",
    };

    if (routeMap[action]) {
      navigate(`${routeMap[action]}?propertyId=${row.id}`, {
        state: { ...row },
      });
    }
  };

  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openAssignModal = (row) => {
    setSelectedProperty(row);
    setSelectedTeamMember("");
    setAssignModalOpen(true);
    handleActionMenuClose();
  };

  const closeAssignModal = () => {
    setAssignModalOpen(false);
    setSelectedProperty(null);
  };

  const openSaleAssignModal = (row) => {
    setSelectedSaleProperty(row);
    setSelectedSaleTeamMember("");
    setSaleAssignModalOpen(true);
    handleActionMenuClose();
  };

  const closeSaleAssignModal = () => {
    setSaleAssignModalOpen(false);
    setSelectedSaleProperty(null);
  };

  const assignLegalTeam = async () => {
    if (!selectedProperty || !selectedTeamMember) return;

    try {
      const response1 = await vendorApi.addPropertyApproval({
        propertyId: selectedProperty.id,
        userId: selectedTeamMember,
        PropertyType: selectedProperty.PropertyType,
      });
      alert("Assigned successfully!");
      closeAssignModal();
    } catch (error) {
      alert("Assignment failed.");
    }
  };

  const assignSaleLegalTeam = async () => {
    if (!selectedSaleProperty || !selectedSaleTeamMember) return;
    try {
      const response1 = await investorApi.addSaleToLegalTeam({
        PropertyType: selectedSaleProperty.PropertyType,
        propertyId: selectedSaleProperty.id,
        userId: selectedSaleTeamMember,
      });
      alert("Assigned successfully!");
      closeAssignModal();
    } catch (error) {
      console.error("Error assigning legal team:", error);
      alert("Assignment failed.");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "column-popover" : undefined;

  const handleFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  useEffect(() => {
    const getProperties = async () => {
      try {
        const res = await vendorApi.getAllSubscriptions();
        const response = await api.getAllProperties();
        console.log(response.data);
        const data = response?.data || [];
        if (response.status === 200 && Array.isArray(data)) {
          const formattedData = data.map((item) => ({
            id: item.Pid,
            ProjectId: item.ProjectId,
            VendorName: item.UserName,
            PropertyName: item.PropertyName,
            project_name: item.ProjectName,
            City: item.City,
            Status: item.Status,
            Facing: item.Facing,
            LatestMarketPrice: item.LatestMarketPrice,
            OriginalPropertyValue: item.OriginalPropertyValue,
            PropertyType: item.PropertyType,
            CurrentValue: item.CurrentValue,
            Address: item.Address,
            SizeInSqFt: item.SizeInSqFt,
            UnitPrice: item.SqFtPrice,
            percentagevalue:item.percentagevalue,
            sqftamount:item.sqftamount,
            NoOfPlots: item.NoOfPlots,
            IconUrl: item.iconUrl,
            ImageGallery: item.ImageGallery,
            Description: item.Description
          }));
          const uniqueRows = Array.from(
            new Map(formattedData.map(item => [item.id, item])).values()
          );

          setRows(uniqueRows);

        } else {
          setRows([]);
        }
      } catch (error) {
       
        if (error.response?.status === 404) {
          setRows([]);
        } else {
          console.error("Failed to fetch properties:", error.message);
        }
      }
    };

    const getLegalTeam = async () => {
      try {
        const response = await investorApi.getLegalTeam();
        setLegalTeam(response.data || []);
      } catch (error) {
        if (error.response?.status === 404) {
          setLegalTeam([]);
        } else {
          console.error("Error fetching legal team:", error.message);
        }
      }
    };

    getProperties();
    getLegalTeam();
  }, []);

  const filteredData = rows.filter((row) => {
    const matchesStatus = statusFilter === "All" || row.Status === statusFilter;
    const matchesSearch = searchQuery === "" || Object.values(row).join(" ").toLowerCase().includes(searchQuery.toLowerCase());
    const matchesMinPrice = minPrice === "" || row.UnitPrice >= parseFloat(minPrice);
    const matchesMaxPrice = maxPrice === "" || row.UnitPrice <= parseFloat(maxPrice);
    const matchesPropertyType = propertyTypeFilter === "All" || String(row.PropertyType) === propertyTypeFilter;

    return matchesSearch && matchesStatus && matchesMinPrice && matchesMaxPrice && matchesPropertyType;
  });

  const renderCellWithFallback = (params) => {
    return params.value === null || params.value === undefined || params.value === '' ? '------' : params.value;
  };

  const columns = [
    { field: "id", headerName: "ID", width: 50, renderCell: renderCellWithFallback },
    {
      field: "PropertyName",
      headerName: "Property Name",
      width: 200,
      renderCell: (params) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleAction("view", params.row)}
        >
          {params.value === null || params.value === undefined || params.value === '' ? '  ------  ' : params.value}
        </span>
      ),
    },
    { field: "City", headerName: "City", width: 200, renderCell: renderCellWithFallback },
    // {
    //   field: "LatestMarketPrice",
    //   headerName: " Property Value",
    //   width: 220,
    //   renderCell: renderCellWithFallback,
    // },
    {
      field: "PropertyType",
      headerName: "Property Type",
      width: 200,
      renderCell: (params) => {
        const typeMap = {
          1: "Project",
          2: "Property",
          3: "Apartment",
          4: "Individual Villa",
        };
        return <span>{typeMap[params.value] || "Unknown"}</span>;
      },
    },
    { field: "Address", headerName: "Address", width: 250, renderCell: renderCellWithFallback },
    { field: "SizeInSqFt", headerName: "Size in Sqft", width: 200, renderCell: renderCellWithFallback },
    { field: "Facing", headerName: "Facing", width: 200 },
    // { field: "UnitPrice", headerName: "SqFt Price", width: 200, renderCell: renderCellWithFallback },
    {
      field: "Status",
      headerName: "Status",
      width: 200,
      sortComparator: (a, b) => {
        const order = {
          Pending: 1,
          InProgress: 2,
          Approved: 3,
          Sold: 4,
          Rejected: 5,
          Other: 6,
        };
        const getOrder = (value) => order[value] || order.Other;
        return getOrder(a) - getOrder(b);
      },
      renderCell: (params) => {
        const status = params.value;
        let color = "gray";
        switch (status) {
          case "Approved":
            color = "green";
            break;
          case "Sold":
            color = "red";
            break;
          case "InProgress":
            color = "#FFA500";
            break;
          case "Pending":
            color = "#1976d2";
            break;
          case "Rejected":
            color = "orange";
            break;
          case "sale Initiated":
            color = 'blue';
            break;
          default:
            color = "gray";
        }
        return (
          <span
            style={{
              fontWeight: "bold",
              color,
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor: `${color}20`,
              display: "inline-block",
              minWidth: "90px",
              textAlign: "center",
            }}
          >
            {status || "------"}
          </span>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Button
            variant="outlined"
            size="small"
            endIcon={<ArrowDropDownIcon />}
            onClick={(event) => handleActionMenuOpen(event, params.row)}
            sx={{
              textTransform: 'none',
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                borderColor: 'primary.dark',
                backgroundColor: 'primary.light',
              }
            }}
          >
            Actions
          </Button>
        );
      },
    },
  ];

  const [selectedFields, setSelectedFields] = useState(columns.map((col) => col.field));
  const displayedColumns = columns.filter((col) => selectedFields.includes(col.field));
  return (
    <>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1, mt: 1 }}>
          Property
        </Typography>

      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 3,
          overflowX: "hidden",
          width: "100%",

        }}
      >

        <div style={{ width: '100%' }}>
          <Card
            sx={{
              flexGrow: 1,
              border: "1px solid lightgray",
              borderRadius: "5px",
            }}
          >
            <CardContent>
              <Grid
                container
                spacing={2}
                alignItems="center"
                direction="row"
                sx={{ width: "100%" }}
              >

                {/* Search Field */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Search By Key words"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "15px",
                      },
                    }}
                  />
                </Grid>

                {/* Min Price */}
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    label="Min Price"
                    type="number"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={minPrice}
                    onChange={(e) => setMinPrice(e.target.value)}
                  />
                </Grid>

                {/* Max Price */}
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    label="Max Price"
                    type="number"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={maxPrice}
                    onChange={(e) => setMaxPrice(e.target.value)}
                  />
                </Grid>

                {/* Type Filter */}
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      value={propertyTypeFilter}
                      onChange={(e) => setPropertyTypeFilter(e.target.value)}
                      label="Type"
                    >
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="1">Project</MenuItem>
                      <MenuItem value="2">Property</MenuItem>
                      <MenuItem value="4">Individual Villa/Home</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Status Filter */}
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={statusFilter}
                      onChange={handleFilterChange}
                      label="Status"
                    >
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="Approved">Approved</MenuItem>
                      <MenuItem value="Sold">Sold</MenuItem>
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="InProgress">InProgress</MenuItem>
                      <MenuItem value="Rejected">Rejected</MenuItem>
                      <MenuItem value="sale Initiated">Sale Initiated</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Icon Button */}
                <Grid item xs={12} sm={2} md={1}>
                  <IconButton onClick={handleIconClick}>
                    <ViewColumnIcon />
                  </IconButton>
                </Grid>

              </Grid>
            </CardContent>

          </Card>

          <Card style={{ height: "100vh", marginTop: "10px", backgroundColor: "#f4f1f1ff" }}>


            <DataGrid
              rows={filteredData}
              columns={displayedColumns}
              disableSelectionOnClick
              pagination
              pageSize={pageSize}
              rowsPerPageOptions={[25, 50, 100]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              sx={{
                height: 650,
                border: '1px solid #ccc',
                borderRadius: 2,
                fontSize: '0.9rem',
                backgroundColor: '#ffffff',
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f0f0f0ff',
                },
                '& .MuiDataGrid-cell': {
                  color: '#333',
                  borderBottom: '1px solid #ddd',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f0f0f0ff',
                  color: 'black',
                  fontWeight: 'bold',
                },
                '& .MuiTablePagination-root': {
                  fontSize: '0.875rem',
                },
              }}
            />
          </Card>
        </div>

        {/* Actions Dropdown Menu */}
        <Popover
          open={Boolean(actionMenuAnchor)}
          anchorEl={actionMenuAnchor}
          onClose={handleActionMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Box sx={{ p: 1, minWidth: 200 }}>
            {selectedRow && (
              <>
                {/* View Action */}
                <MenuItem
                  onClick={() => handleAction("view", selectedRow)}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <VisibilityIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  View
                </MenuItem>

                {/* Approve Action */}
                <MenuItem
                  onClick={() => handleAction("approve", selectedRow)}
                  disabled={!(selectedRow.Status === "Pending" || selectedRow.Status === "InProgress")}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <CheckCircleIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  Approve
                </MenuItem>

                {/* Assign Action */}
                <MenuItem
                  onClick={() => openAssignModal(selectedRow)}
                  disabled={selectedRow.Status !== "Pending"}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <AssignmentIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  Assign
                </MenuItem>

                {/* Assign Sale Action */}
                <MenuItem
                  onClick={() => openSaleAssignModal(selectedRow)}
                  disabled={!(selectedRow.Status === "Approved" || selectedRow.Status === "sale Initiated")}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <AssignmentTurnedInIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  Assign Sale
                </MenuItem>

                {/* Update Sale Action */}
                <MenuItem
                  onClick={() => {
                    handleActionMenuClose();
                    navigate('/investor/updateSale', { state: { rowData: selectedRow } });
                  }}
                  disabled={!(selectedRow.Status === "Approved" || selectedRow.Status === "sale Initiated")}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <UpdateIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  Update Sale
                </MenuItem>



                {/* Update Action */}
                <MenuItem
                  onClick={() => handleAction("update", selectedRow)}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <UpdateIcon fontSize="small" sx={{ color: 'primary.main' }} />
                  Update Market Price
                </MenuItem>
              </>
            )}
          </Box>
        </Popover>

        {/* Rest of your existing Popover and Dialogs remain the same */}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box sx={{ p: 2, maxWidth: 300 }}>
            <Typography variant="subtitle1" gutterBottom>
              Select Columns
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {columns.map((col) => (
                <FormControl
                  key={col.field}
                  component="fieldset"
                  sx={{ m: 0, p: 0 }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFields.includes(col.field)}
                        onChange={() => {
                          setSelectedFields((prev) =>
                            prev.includes(col.field)
                              ? prev.filter((f) => f !== col.field)
                              : [...prev, col.field]
                          );
                        }}
                        sx={{
                          '&.Mui-checked': {
                            color: 'skyblue',
                          },
                        }}
                      />
                    }
                    label={col.headerName}
                    sx={{ m: 0 }}
                  />
                </FormControl>
              ))}
            </Box>
          </Box>
        </Popover>

        {/* Your existing Dialogs remain the same */}
        <Dialog
          open={assignModalOpen}
          onClose={closeAssignModal}
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 3,
              width: "50%",
              maxWidth: '90%',
              backgroundColor: '#ffff',
            }
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', mb: 1 }}>
            Assign <span style={{ color: '#1976d2' }}>{selectedProperty?.PropertyName}</span> for Approval
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Select Legal Team Member</strong>
            </Typography>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Legal Team Member</InputLabel>
              <Select
                value={selectedTeamMember}
                onChange={(e) => setSelectedTeamMember(e.target.value)}
                label="Legal Team Member"
                sx={{ borderRadius: 2, backgroundColor: '#fff' }}
              >
                {Array.isArray(legalTeam) &&
                  legalTeam.map((member) => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions sx={{ mt: 2, justifyContent: 'flex-end' }}>
            <Button onClick={closeAssignModal} sx={{ color: '#666' }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={assignLegalTeam}
              disabled={!selectedTeamMember}
              sx={{ backgroundColor: '#1976d2', ':hover': { backgroundColor: '#115293' } }}
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={assignSaleModalOpen}
          onClose={closeSaleAssignModal}
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 3,
              width: "50%",
              maxWidth: '90%',
              backgroundColor: '#ffff',
            }
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', mb: 1 }}>
            Assign <span style={{ color: '#1976d2' }}>{selectedSaleProperty?.PropertyName}</span> for Sale Update
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Select Legal Team Member</strong>
            </Typography>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Legal Team Member</InputLabel>
              <Select
                value={selectedSaleTeamMember}
                onChange={(e) => setSelectedSaleTeamMember(e.target.value)}
                label="Legal Team Member"
                sx={{ borderRadius: 2, backgroundColor: '#fff' }}
              >
                {Array.isArray(legalTeam) &&
                  legalTeam.map((member) => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions sx={{ mt: 2, justifyContent: 'flex-end' }}>
            <Button onClick={closeSaleAssignModal} sx={{ color: '#666' }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={assignSaleLegalTeam}
              disabled={!selectedSaleTeamMember}
              sx={{ backgroundColor: '#1976d2', ':hover': { backgroundColor: '#115293' } }}
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>

  );
};

export default Property;